import React from "react";

const SectionTitle = ({ title, desc }) => {
  return (
    <div className="row justify-content-center">
      <div className="mb-4 pb-2 text-center">
        <h2>{title}</h2>
        <p className="ma text-muted para-desc mb-0 text-center">{desc}</p>
      </div>
    </div>
  );
};

export default SectionTitle;
